var requestIdleCallback = typeof window !== 'undefined' ? window.requestIdleCallback : null;
var waitForLoad = function waitForLoad(check, callback) {
  var elapsedTime = 0;
  // If the provider fails to load we don't want to keep checking continuously
  // therefore we set a max duration we're willing to wait before executing the callback
  var maxWaitDuration = 10000;
  // If the browser does not support requestIdleCallback we'll wait the fallback duration
  // before executing the callback
  var fallbackDuration = 1000;
  var _scheduleLoad = function scheduleLoad(deadline) {
    if (check() || elapsedTime >= maxWaitDuration) {
      callback();
      return;
    }
    elapsedTime += deadline.timeRemaining();
    requestIdleCallback === null || requestIdleCallback === void 0 || requestIdleCallback(_scheduleLoad);
  };
  if (requestIdleCallback) {
    requestIdleCallback(_scheduleLoad);
  } else {
    setTimeout(callback, fallbackDuration);
  }
};
export default waitForLoad;